import { devEnv } from "./development";
import { APP_ENV_TYPES, IEnvironment } from "./environment";
import { prodEnv } from "./production";
import { releaseEnv } from "./release";
import { stagingEnv } from "./staging";
import { testEnv } from "./test";
import { localEnv } from "./local";
import { orionEnv } from './orion';

const getEnv = (): IEnvironment => {
  const env: APP_ENV_TYPES = (window as any)._env_.APP_ENV;

  switch (env) {
    case "production":
      return prodEnv;
    case "staging":
      return stagingEnv;
    case "test":
      return testEnv;
    case "release":
      return releaseEnv;
    case "development":
      return devEnv;
    case "orion":
      return orionEnv;
    default:
      return localEnv;
  }
};

export default getEnv();
